import React  from 'react';

export default ({ text }) => (
  <div className="description-text">
    {text.split('\n').map(item => <>{item}<br/></>)}
  </div>
);
